export default () => ({
  helpText: {
    marginTop: 8,
    marginLeft: 32
  }
})